<template>
  <section class="register-2">
    <div class="container-scroller">
      <div class="container-fluid page-body-wrapper full-page-wrapper">
        <div
          class="content-wrapper d-flex align-items-stretch auth auth-img-bg"
          style="overflow: hidden"
        >
          <div class="row flex-grow">
            <div class="col-lg-5 d-flex align-items-center justify-content-center register-company">
              <div class="auth-form-transparent text-left p-3 col-md-12 col-lg-9">
                <div class="brand-logo">
                  <img :src="require('@/assets/images/logo2.png')" alt="logo" />
                </div>
                <h6 class="font-weight-light mb-4 custom-size-16">{{ $t('register.subtitle') }}</h6>
                <b-alert v-model="isError" variant="danger">{{ error }}</b-alert>

                <b-form class="custom-input-form preview" @submit.stop.prevent="onSubmit">
                  <div class="register-company-block">
                    <label for="user-register-company" class="text-muted">
                      {{ $t('form.company.label') }}
                    </label>
                    <b-form-input
                      v-model="form.company"
                      id="user-register-company"
                      name="user-register-company"
                      :placeholder="$t('form.company.label')"
                      class="custom-form-input custom-form-input-class text-muted"
                      aria-describedby="input-email-feedback"
                      :state="validateState('company')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-email-feedback">
                      {{ $t('message.error.requiredField') }}
                    </b-form-invalid-feedback>
                  </div>

                  <div class="register-okpo-block my-4">
                    <label for="user-register-okpo" class="text-muted">
                      {{ $t('form.okpo.label') }}
                    </label>
                    <b-form-input
                      id="user-register-okpo"
                      v-model="form.okpo"
                      name="user-register-okpo"
                      :placeholder="$t('form.okpo.label')"
                      class="custom-form-input custom-form-input-class text-muted"
                      aria-describedby="input-email-feedback"
                      :state="validateState('okpo')"
                    ></b-form-input>
                    <b-form-invalid-feedback id="input-email-feedback">
                      {{ $t('message.error.requiredField') }}
                    </b-form-invalid-feedback>
                  </div>

                  <b-form-group>
                    <b-form-checkbox
                      v-model="form.agree"
                      :state="validateState('agree')"
                      class="custom-koeebox-checkbox"
                    >
                      {{ $t('register.form.agree.label') }}
                    </b-form-checkbox>
                  </b-form-group>

                  <div class="my-3">
                    <b-button
                      type="submit"
                      class="btn-block btn-primary btn-lg font-weight-medium auth-form-btn"
                      :disabled="processing"
                      variant="primary"
                    >
                      <p v-if="!processing">{{ $t('button.register.label') }}</p>

                      <div v-if="processing">
                        <b-spinner small type="grow"></b-spinner>
                        <b-spinner small type="grow"></b-spinner>
                        <b-spinner small type="grow"></b-spinner>
                      </div>
                    </b-button>
                  </div>
                </b-form>
              </div>
            </div>
            <div
              class="col-lg-7 col-md-12 login-half-bg d-flex flex-row align-items-center justify-content-center position-relative pb-5 pb-md-0"
            >
              <text-for-login-register-page></text-for-login-register-page>
              <p
                class="text-white font-weight-medium text-center flex-grow align-self-end position-absolute"
              >
                Copyright &copy; {{ date }}
                All rights reserved.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';
import { apolloClientClearCache } from '@/plugins/apollo';

import userInfoQuery from '@/api/user/userAllInfo.gql';
import registerPmMutation from '@/api/user/mutations/registerPm.gql';

export default {
  name: 'SmartOeeRegisterCompany',
  mixins: [validationMixin],
  data() {
    return {
      registerError: '',
      form: {
        company: '',
        okpo: '',
        agree: true,
      },
    };
  },
  computed: {
    date() {
      return new Date().getFullYear();
    },
    isError() {
      return !!this.registerError;
    },
    error() {
      return this.registerError;
    },
    processing() {
      return this.$store.getters.getProcessing;
    },
    name() {
      return this.currentUser ? this.currentUser.firstName : '';
    },
    surname() {
      return this.currentUser ? this.currentUser.secondName : '';
    },
    email() {
      return this.currentUser ? this.currentUser.login : '';
    },
    phone() {
      return this.currentUser ? this.currentUser.phoneBusiness : '';
    },
  },
  validations: {
    form: {
      company: {
        required,
      },
      okpo: {
        required,
      },
      agree: {
        checked: (value) => value === true,
      },
    },
  },
  apollo: {
    currentUser: {
      query() {
        return userInfoQuery;
      },
      deep: true,
      update(data) {
        const queryData = data[Object.keys(data)[0]];
        if (queryData && queryData.currentUser) {
          return {
            ...queryData.currentUser,
            login: this.$authCore.userLogin,
          };
        } else {
          return null;
        }
      },
      error(e) {
        this.$store.commit('SET_ERROR', e.message);
      },
    },
  },
  methods: {
    validateState(name) {
      const { $dirty, $error } = this.$v.form[name];
      return $dirty ? !$error : null;
    },
    onSubmit() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) {
        this.form._invalidSave = true;
        return;
      }
      this.registerError = '';

      this.$apollo
        .mutate({
          mutation: registerPmMutation,
          variables: {
            firstName: this.name,
            lastName: this.surname,
            email: this.email,
            phone: this.phone,
            orgName: this.form.company,
            okpo: this.form.okpo,
          },
        })
        .then(() => {
          this.$store.commit('SET_PROCESSING', false);
          this.$store.commit('REMOVE_PREVIEW_MODE');
          apolloClientClearCache();
          this.$router.push({ name: 'CreatingCompany' });
        })
        .catch((e) => {
          this.$store.commit('SET_PROCESSING', false);
          this.registerError = e.message;
        });
    },
  },
};
</script>
<style lang="scss" scoped>
.register-tabs {
  margin-top: 0.5rem;
}
.register-company {
  background-color: #191c24;
}
.position-absolute {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  white-space: nowrap;
}
.custom-size-16 {
  font-size: 16px;
}
</style>
